export default function CStructures() {
  return <h2>C Structures</h2>;
}
